<template>
  <BaseLayout>
    <div class="kt-subheader   kt-grid__item" id="kt_subheader">
      <div class="kt-container  kt-container--fluid ">
        <div class="kt-subheader__main">
          <h3 class="kt-subheader__title">
            Edit Profile
          </h3>
          <span
            class="kt-subheader__separator kt-subheader__separator--v"
          ></span>
          <div class="kt-subheader__group" id="kt_subheader_search">
            <span class="kt-subheader__desc" id="kt_subheader_total">
              {{ fullName }}
            </span>
          </div>
        </div>
        <div class="kt-subheader__toolbar">
          <a
            href="#"
            @click.prevent="$router.push({ name: 'home' })"
            class="btn btn-default btn-bold"
          >
            Back
          </a>
          <div class="btn-group">
            <button
              @click.prevent="save"
              type="button"
              class="btn btn-brand btn-bold"
              :class="{ disabled: busy }"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="mt-5 kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
    >
      <div
        class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid"
      >
        <div class="kt-portlet kt-portlet--tabs">
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-toolbar">
              <ul
                class="nav nav-tabs nav-tabs-space-xl nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand"
                role="tablist"
              >
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    data-toggle="tab"
                    href="#tab-profile"
                    role="tab"
                    aria-selected="false"
                    @click="activeForm = $refs.profileForm"
                  >
                    <StackSvg />
                    Profile
                  </a>
                </li>

                <li class="nav-item">
                  <a
                    class="nav-link"
                    data-toggle="tab"
                    href="#tab-billing"
                    role="tab"
                    aria-selected="false"
                    @click="activeForm = $refs.billingDetailsForm"
                  >
                    <UserSvg />
                    Billing Details
                  </a>
                </li>

                <li class="nav-item">
                  <a
                    class="nav-link"
                    data-toggle="tab"
                    href="#tab-password"
                    role="tab"
                    aria-selected="true"
                    @click="activeForm = $refs.changePasswordForm"
                  >
                    <UserShield />
                    Change Password
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="kt-portlet__body">
            <div class="tab-content">
              <div class="tab-pane active" id="tab-profile" role="tabpanel">
                <ProfileForm ref="profileForm" />
              </div>
              <div class="tab-pane" id="tab-billing" role="tabpanel">
                <BillingDetailsForm ref="billingDetailsForm" />
              </div>
              <div class="tab-pane" id="tab-password" role="tabpanel">
                <ChangePassword ref="changePasswordForm" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import { mapGetters } from "vuex";
import BaseLayout from "@/layouts/BaseLayout.vue";
import StackSvg from "@/svgs/StackSvg.vue";
import UserSvg from "@/svgs/UserSvg.vue";
import UserShield from "@/svgs/UserShield.vue";
import ProfileForm from "./-ProfileForm.vue";
import BillingDetailsForm from "./-BillingDetailsForm.vue";
import ChangePassword from "./-ChangePassword.vue";

export default {
  name: "EditProfile",
  components: {
    BaseLayout,
    StackSvg,
    UserSvg,
    UserShield,
    ProfileForm,
    BillingDetailsForm,
    ChangePassword,
  },

  data() {
    return {
      activeForm: null,
    };
  },

  computed: {
    ...mapGetters({
      user: "auth/user",
    }),

    fullName() {
      return `${this.user.first_name} ${this.user.last_name}`;
    },

    busy() {
      if (this.activeForm) {
        return this.activeForm?.busy || false;
      }
      return false;
    },
  },

  mounted() {
    this.activeForm = this.$refs.profileForm;
  },

  methods: {
    save() {
      if (this.activeForm) {
        this.activeForm.save();
      }
    },
  },
};
</script>
